/**
 * Checkbox (Task 4) — a token-styled wrapper over a native checkbox so it themes
 * with the accent and supports an indeterminate state (the table's select-all
 * when only some rows on the page are selected). Always pass an `ariaLabel` since
 * these are used without a visible label (table column). Clicks are stopped from
 * bubbling so toggling a row's checkbox never also opens the row.
 */
import { useEffect, useRef } from "react";

export function Checkbox({
  checked,
  indeterminate = false,
  disabled = false,
  onChange,
  ariaLabel,
  className,
}: {
  checked: boolean;
  indeterminate?: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  ariaLabel: string;
  className?: string;
}) {
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (ref.current) ref.current.indeterminate = indeterminate && !checked;
  }, [indeterminate, checked]);

  return (
    <input
      ref={ref}
      type="checkbox"
      className={`checkbox${className ? ` ${className}` : ""}`}
      checked={checked}
      disabled={disabled}
      aria-label={ariaLabel}
      onChange={(e) => onChange(e.target.checked)}
      onClick={(e) => e.stopPropagation()}
    />
  );
}
